import axios from 'axios'
import type { HookResult } from 'nuxt/schema'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:error', (err): HookResult => {
    if (axios.isAxiosError(err)) {
      console.warn('[app:error] suppressed:', err.status)
      // 🚩 Now TS knows `true` is a valid HookResult
      return true as unknown as HookResult
    }
    // otherwise implicitly returns `undefined` (also allowed)
  })
})
